import {defineStore} from 'pinia'
import {useUserStore} from "./user";
// import Swal from 'sweetalert2'
import router from '@/router/index';


export const useObjectStore = defineStore('object', {
    // a function that returns a fresh state
    state: () => ({
        loading: false,
        totalRecords: 0,
        serverOptions: {
            page: 0,
            rows: 10,
        },
    }),
    // optional getters
    getters: {
        userStore: () => useUserStore(),
    },
    // optional actions
    actions: {
        async apiIndex(base_type, {paginated = false} = {}) {
            let kdnr = this.userStore.user.organisation.kdnr || router.currentRoute.value.query.kdnr
            const params = {kdnr, base_type}
            if (paginated) {
                params.page = this.serverOptions.page + 1
                params.rows = this.serverOptions.rows
            }

            this.loading = true
            try {
                const response = await this.apiClientV2.get(`/objects`, {params})
                if (paginated) {
                    const responseData = response?.data
                    const objects = Array.isArray(responseData) ? responseData : responseData?.objects || []
                    this.totalRecords = Number(responseData?.totalRecords || objects.length)
                }
                return response
            } finally {
                this.loading = false
            }
        },
        apiSort(ids) {
            const kdnr = this.userStore.user.organisation.kdnr || router.currentRoute.value.query.kdnr
            const payload= {kdnr, ids}
            return this.apiClientV2.put(`/objects/sort`, payload)
        },
        apiHostCandidates(lang = 'de', excludeObjectId = null) {
            const kdnr = this.userStore.user.organisation.kdnr || router.currentRoute.value.query.kdnr
            const params = {kdnr, lang}
            if (excludeObjectId) {
                params.exclude_object_id = excludeObjectId
            }
            return this.apiClientV2.get('/objects/host_candidates', {params})
        },
    },
})
